export const safeStorageGet = (key: string, storage?: Storage): string => {
  if (!key) {
    return ''
  }
  try {
    const target = storage || window.localStorage
    return target.getItem(key) || ''
  } catch {
    return ''
  }
}

export const safeStorageSet = (key: string, value: string, storage?: Storage): boolean => {
  if (!key) {
    return false
  }
  try {
    const target = storage || window.localStorage
    target.setItem(key, value)
    return true
  } catch {
    return false
  }
}

export const safeStorageRemove = (key: string, storage?: Storage): boolean => {
  if (!key) {
    return false
  }
  try {
    const target = storage || window.localStorage
    target.removeItem(key)
    return true
  } catch {
    return false
  }
}
